export default "__VITE_ASSET__CXwwnuPR__"